import { useTranslation } from "react-i18next";
import { useProduct } from "~/contexts/product-context";
import { ListLoading } from "~/components/skeletons/list-loading";
import { Text } from "~/components/text";
import { useProductActions } from "~/hooks/use-product-actions";
import { actionInProgress } from "~/utils/status";
import { EmptyList } from "~/components/empty/empty-list";
import { Button } from "~/components/button";
import { BasePanel } from "~/components/base-panel";
import { useSubjectsData } from "./subjects-list";
import { Codes } from "./codes";

export const GeneratedCodes = () => {
  const { product } = useProduct();
  const { t } = useTranslation(["productDetails"]);
  const { generateProductSubjects } = useProductActions();
  const { isEmptyList: isEmptySubjectsList } = useSubjectsData(
    "generated",
    product,
  );

  const { isEmptyList: isEmptyQualifiersList } = useSubjectsData(
    "generated",
    product,
  );

  const isGeneratingProduct = actionInProgress(
    product?.actions?.thema?.actions?.generate,
  );

  if (isGeneratingProduct) {
    return (
      <BasePanel
        title={t("thema.tabs.generated")}
        className="h-full"
        wrapper={false}
      >
        <div className="flex items-center justify-center p-6 h-full">
          <div className="items-center flex flex-col">
            <div className="relative w-59 h-20">
              <ListLoading />
            </div>
            <Text variant="label" className="text-center">
              {t("thema.loading")}
            </Text>
          </div>
        </div>
      </BasePanel>
    );
  }

  return (
    <BasePanel
      isEmpty={isEmptySubjectsList && isEmptyQualifiersList}
      emptyComponent={
        <div className="h-full items-center justify-center flex">
          <EmptyList
            title={t("thema.generateTitle")}
            text={t("thema.generateDescription")}
            orientation="vertical"
            buttons={[
              <Button
                key="button_generate_keywords"
                label={t("general:buttons.generate")}
                icon="sparkles"
                onClick={() => generateProductSubjects(product?.id || "")}
                size="small"
                analyticsId="button_generate_keywords"
              />,
            ]}
          />
        </div>
      }
      title={t("thema.tabs.generated")}
      className="h-full"
      testId="generated-codes"
    >
      <Codes variant="generated" />
    </BasePanel>
  );
};
